import { v4 as uuid } from "uuid";
import { defineStore } from "pinia";
import { trackAppFeature } from "@/analytics/app-analytics";
import { ref } from "vue";
import type { ChatMessage } from "@/types/chatbot.types";
import api from "@/APIClient";

export const useChatbotStore = defineStore("chatbotStore", () => {
  const messages = ref<ChatMessage[]>([]);
  const isLoading = ref(false);
  const conversationId = ref<number | null>(null);

  async function sendMessage(text: string) {
    // The message content itself never reaches analytics.
    trackAppFeature("chatbot_message_sent");
    const userMessage: ChatMessage = {
      id: uuid(),
      role: "user",
      content: text,
      timestamp: new Date(),
    };
    messages.value.push(userMessage);

    isLoading.value = true;
    try {
      const response = await api.sendChatbotMessage(text, conversationId.value);

      conversationId.value = response.conversationId;

      const assistantMessage: ChatMessage = {
        id: uuid(),
        role: "assistant",
        content: response.reply,
        timestamp: new Date(),
      };
      messages.value.push(assistantMessage);
    } catch {
      const errorMessage: ChatMessage = {
        id: uuid(),
        role: "assistant",
        content: "error",
        timestamp: new Date(),
      };
      messages.value.push(errorMessage);
    } finally {
      isLoading.value = false;
    }
  }

  function clearConversation() {
    messages.value = [];
    conversationId.value = null;
  }

  return {
    messages,
    isLoading,
    conversationId,
    sendMessage,
    clearConversation,
  };
});
